module.exports = " <div v-el:c :class=\"{'value':true , 'sort-handle': true}\" contenteditable=true :placeholder=placeholder @paste=handlePaste @keydown=handleKeyDown @focus=handleFocus @blur=handleBlur @click=handleClick></div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/input-box.vue
 ** module id = 52
 ** module chunks = 1
 **/